import axios from 'axios';
import { GET_ALL_DRINKS } from './actionTypes';
import { Constants } from '../../constants';

// eslint-disable-next-line import/prefer-default-export
export const getAllDrinks = (page, limit, query, drinkId) => (dispatch) => {
  axios
    .get(`${Constants.apiPath}/cigars/datatables/pairings`, {
      params: {
        page,
        limit,
        q: query,
        id: drinkId,
      },
    })
    .then((res) => {
      dispatch({
        type: GET_ALL_DRINKS,
        payload: {
          data: res.data.data,
          totalSize: res.data.recordsFiltered,
        },
      });
    })
    .catch((e) => {
      console.log(e.message);
    });
};
